<template>
  <!-- <transition xname="slide"> -->
    <div :class="{'swiper': !isDesktop}">
      <Fetching v-if="isLoading" />

      <!-- <desktop-stacks v-else-if="showDesk('stack')"/> -->
      <!-- <desktop-dashboard v-else-if="showDesk('dashboard', 'both')"/> -->
      <desktop-history v-else-if="showDesk('history')"/>

      <div v-else class="swiper-wrap">
        <div class="safe-area-blur"></div>
        <button class="close" @click="close()" :class="{'hasImage' :  showImage || showMap}">
          <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M0.22037 1.28002C-0.0734566 0.986194 -0.0734566 0.511071 0.22037 0.22037C0.514196 -0.0703308 0.98932 -0.0734566 1.28002 0.22037L6 4.94035L10.72 0.22037C11.0138 -0.0734566 11.4889 -0.0734566 11.7796 0.22037C12.0703 0.514196 12.0735 0.98932 11.7796 1.28002L7.05965 6L11.7796 10.72C12.0735 11.0138 12.0735 11.4889 11.7796 11.7796C11.4858 12.0703 11.0107 12.0735 10.72 11.7796L6 7.05965L1.28002 11.7796C0.986194 12.0735 0.511071 12.0735 0.22037 11.7796C-0.0703308 11.4858 -0.0734566 11.0107 0.22037 10.72L4.94035 6L0.22037 1.28002Z" fill="white"/>
          </svg>
        </button>

        <!-- <button v-if="isDesktop && oCard.type !== 'intro'" class="desktop-next" @click="next()">
          <span>{{ oCard.end ? 'Done' : 'Next' }}</span>
          <svg width="17" height="13" viewBox="0 0 17 13" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M16.2812 7.03135C16.575 6.7376 16.575 6.2626 16.2812 5.97197L11.0312 0.718848C10.7375 0.425098 10.2625 0.425098 9.97188 0.718848C9.68125 1.0126 9.67813 1.4876 9.97188 1.77822L13.9406 5.74697H1.25C0.834375 5.74697 0.5 6.08135 0.5 6.49697C0.5 6.9126 0.834375 7.24697 1.25 7.24697H13.9406L9.97188 11.2157C9.67813 11.5095 9.67813 11.9845 9.97188 12.2751C10.2656 12.5657 10.7406 12.5688 11.0312 12.2751L16.2812 7.03135Z" fill="black"/>
          </svg>
        </button> -->

        <div v-if="showMap && !isFullSize" class="map" :class="{'reduced' : oCard.type === 'outro'}" :style="mapBackgroundStyle">
          <DotMap :focusCountry="focusCountry" />
        </div>

        <swiper-container
          :slidesPerView="1"
          allow-touch-move="false"
          :auto-height="true"
          class="stacks" 
          ref="swiper"
          >
          <swiper-slide v-for="(slide, swiperIndex) in getStructure" :key="slide.slug" :id="slide.slug" class="slide" :class="`slide-${slide.type}`">
            <!-- <div v-if="showImage" class="image" :class="{'reduced' : slide.type === 'outro'}" :style="backgroundStyle"></div> -->
            
            <div v-if="showImage" class="image-wrap">
              <div v-if="showImage" class="image" :class="{'reduced' : slide.type === 'outro'}">
                <img :src="getImageUrl" style="width: 100%; height: 100%; object-fit: cover;"/>
              </div>
              <div v-if="showImage" class="blur"></div>
            </div>

            <div class="content" :class="[{'hasImage' :  showImage, 'hasMap' :  showMap, 'isIntro' : isIntro, 'isFullSize' : isFullSize}, `type-${slide.type}`]" :data-type="slide.type">
              <component :data-type="slide.type" :is="slide.type" :isActive="swiperIndex == swiperActiveIndex" :slide="slide" :meta="stack.meta" :stack="currentStack" :stories="getStories" :articles="getArticles" @featureImage="featureImage" @swiperUpdate="swiperUpdate" @readMore="readMore" @enableNextAction="enableNextAction" @next="next" />
            </div>
          </swiper-slide>
        </swiper-container>
      </div>

      <Message />
    </div>
  <!-- </transition> -->
</template>

<script>
  // import 'swiper/css';
  // import 'swiper/css/effect-cube';
  import 'swiper/css/pagination';
  import API from 'app/axios';
  import Fetching from '@/components/v5/Fetching.vue';

  import DotMap from '@/components/v5/dotmap/DotMap.vue';
  import Intro from '@/components/v5/stacks/cards/Intro.vue';
  import StoryCard from '@/components/v5/stacks/cards/StoryCard.vue';
  import Bio from '@/components/v5/stacks/cards/Bio.vue';
  import Quiz from '@/components/v5/stacks/cards/Quiz.vue';
  import Outro from '@/components/v5/stacks/cards/Outro.vue';
  import Newsle from '@/components/v5/stacks/cards/Newsle.vue';
  import FiveIntro from '@/components/v5/stacks/cards/five-thrive/Intro.vue';
  import FiveQuestion from '@/components/v5/stacks/cards/five-thrive/Question.vue';
  import FiveOutro from '@/components/v5/stacks/cards/five-thrive/Outro.vue';
  import Question from '@/components/v5/stacks/cards/Question.vue';
  import Score from '@/components/v5/stacks/cards/Score.vue';
  import Onboarding from '@/components/v5/stacks/cards/Onboarding.vue';
  import Invite from '@/components/v5/stacks/cards/Invite.vue';
  import Auth from '@/components/v5/stacks/cards/Auth.vue';
  import DownloadApp from '@/components/v5/stacks/cards/DownloadApp.vue';
  import DashboardSummary from '@/components/v5/stacks/cards/DashboardSummary.vue';
  import DashboardFocus from '@/components/v5/stacks/cards/DashboardFocus.vue';
  import GoPro from '@/components/v5/stacks/cards/GoPro.vue';
  import ProfileUsername from '@/components/v5/stacks/cards/ProfileUsername.vue';
  import ProfileImage from '@/components/v5/stacks/cards/ProfileImage.vue';
  import Coaching from '@/components/v5/stacks/cards/Coaching.vue';
  import Finalise from '@/components/v5/stacks/cards/Finalise.vue';
  import Achievement from '@/components/v5/stacks/cards/Achievement.vue';
  import Breathe from '@/components/v5/stacks/cards/Breathe.vue';
  import Completed from '@/components/v5/stacks/cards/Completed.vue';
  import Notifications from '@/components/v5/stacks/cards/Notifications.vue';
  import Contact from '@/components/v5/stacks/cards/Contact.vue';
  import Debug from '@/components/v5/stacks/cards/Debug.vue';
  import SwitchOff from '@/components/v5/stacks/cards/SwitchOff.vue';
  import Unlock from '@/components/v5/stacks/cards/Unlock.vue';
  import History from '@/components/v5/stacks/cards/History.vue';
  import ThreadIntro from '@/components/v5/stacks/cards/ThreadIntro.vue';
  import ThreadContent from '@/components/v5/stacks/cards/ThreadContent.vue';
  import LowNews from '@/components/v5/stacks/cards/LowNews.vue';

  // desktop fallbacks
  import DesktopStacks from '@/components/v5/desktop/APIStacks.vue';
  // import DesktopDashboard from '@/components/v5/desktop/Dashboard.vue';
  import DesktopHistory from '@/components/v5/desktop/History.vue';
  import Message from '@/components/v5/modals/Message.vue';

  export default {
    data() {
      return {
        featuredImage: null,
        imageOpacity: 1,
        focusCountry: 'GB',
        enableNext: false,
        iTimeStart: (new Date()).getTime(),
        oCard: {}, // the current card object (sorry if this is here, I can't find it)
        bBounceSafe: false,
        swiperActiveIndex: 0,
        thread: null,
        bSignedInAtStart: false,
      }
    },

    components: {
      Fetching,
      DotMap,
      Intro,
      StoryCard,
      Bio,
      Quiz,
      Outro,
      Newsle,
      FiveIntro,
      FiveQuestion,
      FiveOutro,
      Question,
      Score,
      Onboarding,
      Invite,
      Auth,
      DownloadApp,
      DashboardSummary,
      DashboardFocus,
      GoPro,
      ProfileUsername,
      ProfileImage,
      Coaching,
      Finalise,
      Achievement,
      Breathe,
      Completed,
      Notifications,
      Contact,
      Debug,
      SwitchOff,
      Unlock,
      History,
      ThreadIntro,
      ThreadContent,
      LowNews,
      // desktop fallbacks
      DesktopStacks,
      // DesktopDashboard,
      DesktopHistory,
      Message
    },

    async mounted () {
      // Ensure new swiper instance, the next button is not disabled until called
      this.EventBus.$emit('tab:hide-next', false);
      this.$layoutEngine.resetSwiper();

      // track whether we *were* signed in at the start (since, in auth, this.isSignedIn is mutable!)
      this.bSignedInAtStart = this.isSignedIn;

      // not exempt == a mechanical, trackable deck
      await this.fetchStack();

      if (!this.cardSlug && this.stack?.structure?.[0]?.slug) {
        // No route stack slug found but exists
        this.$router.replace({ 
          path: `${this.$route.path}/${this.stack.structure[0].slug}`, 
          query: this.$route.query 
        })
      }      

      // Always check and handle the route
      setTimeout(() => {
        this.handleRoute();
      }, 100)

      // Listen for swipe calls
      this.EventBus.$on('swiper:next', () => {
        this.next();
      });

      this.EventBus.$on('swiper:outro', () => {
        this.outro();
      });

      this.EventBus.$on('swiper:close', () => {
        this.close();
      });

      // Listen for scroll events
      window.addEventListener('scroll', this.handleScroll);

      // Listen for Swiper movement
      window.setTimeout(() => {
        const oSwiper = (this.$refs.swiper?.$el || this.$refs.swiper)?.swiper;
        if (!oSwiper) return;

        oSwiper.on('slideChange', () => {
          this.swiperActiveIndex = oSwiper.activeIndex;
        }); 

        this.setCurrentCard();
        setTimeout(() => {
          this.updateActionBar();
        }, 500);

      }, 100);
     

      // set this.oCard
      this.setCurrentCard();

      // let iTry = 0;
      // let tTry = setInterval(() => {
      //   if (iTry > 100) {
      //     console.log(`TRY: Giving up!`);
      //     clearInterval(tTry);
      //     return;
      //   }
      //   if (!this.$refs.swiper) {

      //   }
      //     console.log(`TRY: Giving up!`);
      // }, 100);
    },

    beforeDestroy() {
      window.removeEventListener('scroll', this.handleScroll);
    },

    computed: {
      isLoading() {
        return !this.stack;
      },

      isAlpha() {
        return this.$store.getters.isAlpha;
      },

      isDesktop() {
        return this.$layoutEngine.isDesktop;
      },

      isSignedIn() {
        return this.$store.getters.isLoggedIn; 
      },

      getAccount() {
        return this.$store.getters.getAccount;
      },

      isApp() {
        return this.$store.getters.hasApp;
      },

      device() {
        return this.$userEngine.getDevice();
      },

      // renamed to convention
      stackSlug() {
        return this.$route?.params?.slug; 
      },

      editionSlug() {
        return this.stack?.meta?.edition?.slug || '';
      },

      // renamed to convention
      cardSlug() {
        return this.$route.params.stack;
      },

      threadSlug() {
        const slug = this.$route.params.stack;
        const [author, slugPart] = slug.split('-thread:');
        return { author, slug: slugPart };
      },

      apiExempt() {
        console.log(this.stackSlug);
        switch (this.stackSlug) {
          case 'notifications':
          case 'contact':
          case 'debug':
          case 'newsle':
          case 'five-to-thrive':
          case 'pro':
          case 'unlock':
          case 'dashboard':
          case 'welcome':
          case 'profile':
          case 'thread':
          case 'history':
            // Api call exempt
            return true
          default:
            // all onboarding
            if (/^coaching/.test(this.stackSlug)) {
              return true;
            }
            // Api call is not exempt
            return false;
        }
      },

      stack() {
        if (this.apiExempt) {
          
          // tell the layout engine we're in (hacky! sorry)
          this.$layoutEngine.goDeepSwiper();

          switch (this.stackSlug) {
            case 'debug':
            return {
              structure: [
                {
                  type: 'debug',
                  slug: 'debug',
                  content: {
                    byline: `Just some tools for us to test everything's working amazingly.`,
                    title: `Stay in the know`,
                  },
                  dot: false,
                }
              ]
            }

            case 'notifications':
            return {
              structure: [
                {
                  type: 'notifications',
                  slug: 'notifications',
                  content: {
                    byline: 'Enable notifications, never miss an update and keep your streak on track.',
                    title: `Stay in the know`,
                  },
                  dot: false,
                }
              ]
            }

            case 'contact':
            return {
              structure: [
                {
                  type: 'contact',
                  slug: 'contact',
                  content: {
                    byline: `We want to hear from you.<br/>Good or bad, we love feedback.`,
                    title: `Tell us what you think.`,
                  },
                  dot: false,
                }
              ]
            }

            case 'history': 
            return {
              structure: [
                {
                  type: 'history',
                  slug: 'history',
                  byline: `Your reading history`,
                  title: `Everything you have read in the last 60 days`,
                  history: [
                    {
                      date: new Date(Date.now() - 0 * 24 * 60 * 60 * 1000).toISOString().split('T')[0],
                      stories: [
                        {
                          name: 'MoD Reviews Afghan Applications',
                          slug: 'pr2u5pn2reajkw2u',
                          image: 'https://nourished.news/images/sized/1200x_/0060d5fc-qx95.jpg',
                          stack: 'Five-a-day'
                        },
                        {
                          name: 'Violence Erupts in Jerusalem',
                          slug: 'b9d9kg15yvejwzan',
                          image: 'https://nourished.news/images/sized/1200x_/5858f592-qx95.jpg',
                          stack: 'Five-a-day'
                        },
                        {
                          name: 'Clownfish Shrink for Survival',
                          slug: 'z1nl3vx4xyopxsfj',
                          image: 'https://nourished.news/images/sized/1200x_/cf5a8da9-qx95.jpg',
                          stack: 'Five-a-day'
                        },
                      ]
                    },
                    {
                      date: new Date(Date.now() - 1 * 24 * 60 * 60 * 1000).toISOString().split('T')[0],
                      stories: [
                        {
                          name: 'MoD Reviews Afghan Applications',
                          slug: 'pr2u5pn2reajkw2u',
                          image: 'https://nourished.news/images/sized/1200x_/0060d5fc-qx95.jpg',
                          stack: 'Five-a-day'
                        },
                        {
                          name: 'Violence Erupts in Jerusalem',
                          slug: 'b9d9kg15yvejwzan',
                          image: 'https://nourished.news/images/sized/1200x_/5858f592-qx95.jpg',
                          stack: 'Five-a-day'
                        },
                        {
                          name: 'Clownfish Shrink for Survival',
                          slug: 'z1nl3vx4xyopxsfj',
                          image: 'https://nourished.news/images/sized/1200x_/cf5a8da9-qx95.jpg',
                          stack: 'Five-a-day'
                        },
                      ]
                    }
                  ]
                }
              ]
            }

            case 'thread': 
              return this.getThreadFlow;

            case 'profile':
              return {
                structure: [
                  {
                    type: 'profile-image',
                    slug: 'image'
                  },
                  {
                    type: 'profile-username',
                    slug: 'username',
                  },
                  
                ]
              }

            case 'pro':
              return {
                structure: [
                  {
                    type: 'go-pro'
                  }
                ]
              }

            
            case 'newsle':
              return {
                structure: [
                  {
                    type: 'newsle'
                  }
                ]
              }
            
            case 'five-to-thrive':
              return {
                structure: [
                  {
                    type: 'five-intro'
                  },
                  {
                    type: 'five-question',
                    slug: 'q-1',
                    question: `Why is Donald Trump in the news today?`,
                    options: [
                      {
                        answer: `Donald Trump has retired as President of the United States`,
                        correct: true,
                        slug: 'one',
                      },
                      {
                        answer: `5 senators has resigned over his recent comments`,
                        correct: false,
                        slug: 'two',
                      },
                      {
                        answer: `He is proposing to buy Canada from the Canadians`,
                        correct: false,
                        slug: 'three',
                      },
                    ]
                  },
                  {
                    type: 'five-outro',
                    slug: 'results',
                  },
                ]
              }

            case 'unlock':
              return {
                structure: [
                  {
                    type: 'unlock'
                  }
                ]
              }

            case 'dashboard':
              return this.getDashboardFlow;

            case 'welcome': 
              return this.getWelcomeFlow;
          }
        }


        if (/^coaching/.test(this.stackSlug)) {
          // console.log('COACHING', this.stackSlug)
          return this.$coachingEngine.getCoachingStack(this.stackSlug);
        }

        // console.warn(`\x1b[36mSwipe: Get stack ... ${this.stackSlug}`);
        return this.stackSlug ? this.$store.getters.getStack(this.stackSlug) : {};
      },

      getThreadFlow() {
        if (!this.thread) { return; }

        let structure = [
          {
            type: 'thread-intro',
            slug: 'intro',
            content: this.thread
          },
        ]

        // console.log('Els', this.thread)

        this.thread.elements.forEach((element) => {
          structure.push({
            type: 'thread-content',
            slug: element.slug,
            thread: this.thread,
            content: element,
          })
        })

        return {
          structure: structure
        };
      },

      getDashboardFlow() {
        // return {
        //   structure: [
        //     {
        //       type: 'achievement',
        //       slug: 'achievement',
        //       content: {
        //         title: 'Great work',
        //         byline: 'Amazing you did foo',
        //         topics: [
        //           {
        //             img: '/flags/uk.png',
        //             name: 'Ukraine'
        //           }
        //         ]
        //       }
        //     }
        //   ]
        // }

        const tracks = this.$userEngine.dialTracks;
        const titles = {
          time: 'Time you spent reading the news',
          topics: 'Topics you read about recently',
          locales: 'Places you visited around the world',
        }

        const structure = [
          {
            type: 'dashboard-summary',
            slug: 'summary',
            title: `Here's how your day's going`,
          },
        ]

        tracks.forEach((track) => {
          structure.push({
            type: 'dashboard-focus',
            slug: track.slug,
            title: titles[track.slug],
          })
        });

        return {
          structure: structure
        };
      },

      getWelcomeFlow() {
        if (this.$route.query.n === 'sign-in') {
          // Onboarding flow should only show auth. Coming from login on lander
          return {
            structure: [
              {
                type: 'auth',
                slug: 'auth'
              },
            ]
          }
        }

        const flow = {
          structure: [
            // {
            //   type: 'onboarding',
            //   slug: 'intro',
            //   template: 'open',
            // },

            {
              type: 'onboarding',
              slug: 'nourish',
              template: 'nourish',
              dot: false,
            },

            {
              type: 'onboarding',
              slug: 'read',
              template: 'read',
              dot: false,
            },

            {
              type: 'onboarding',
              slug: 'watch',
              template: 'watch',
              dot: false,
            },
            
            {
              type: 'onboarding',
              slug: 'track',
              template: 'track',
              dot: false,
            },

            {
              type: 'onboarding',
              slug: 'detox',
              template: 'detox',
              dot: false,
            },

            // {
            //   type: 'onboarding',
            //   slug: 'pledge',
            //   template: 'pledge',
            //   dot: false,
            // },

            // {
            //   type: 'onboarding',
            //   slug: 'why',
            //   template: 'why',
            //   dot: false,
            // },

            // {
            //   type: 'onboarding',
            //   slug: 'qna',
            //   template: 'qna',
            //   dot: false,
            // },

            {
              type: 'score',
              slug: 'news',
              byline: 'First check-in',
              title: `How do you feel after reading the news?`,
            },

            {
              type: 'question',
              slug: 'media',
              byline: `Your current news diet…`,
              title: `Where do you currently get most of your news?`,
              action: {
                message: ``
              },
              questions: [
                {
                  option: `Traditional publishers`,
                  slug: 'traditional',
                  icon: 'onboarding-publisher',
                  icon_height: '17px',
                  class: 'green'
                },
                {
                  option: `TV, Radio & Podcasts`,
                  slug: 'audio',
                  icon: 'onboarding-tv',
                  icon_height: '16px',
                  class: 'green'
                },
                {
                  option: `A different news app`,
                  slug: 'newsapp',
                  icon: 'onboarding-app',
                  icon_height: '19px',
                  class: 'blue'
                },
                {
                  option: `Social media`,
                  slug: 'social',
                  icon: 'onboarding-social-media',
                  icon_height: '17px',
                  class: 'blue'
                },
                {
                  option: `I mostly avoid the news`,
                  slug: 'avoid',
                  icon: 'onboarding-ignore',
                  icon_height: '18px',
                  class: 'red'
                },
              ]
            },


            {
              type: 'question',
              slug: 'level',
              byline: `Last question, promise!…`,
              title: `How much news do you see each day?`,
              action: {
                message: ``
              },
              questions: [
                {
                  option: `More than I'd like`,
                  slug: 'high-overload',
                  icon: 'onboarding-up',
                  icon_height: '14px',
                  class: 'red'
                },
                {
                  option: `Quite a lot`,
                  slug: 'high-deep',
                  icon: 'onboarding-focus',
                  icon_height: '19px',
                  class: 'green'
                },
                {
                  option: `Totally average`,
                  slug: 'normal',
                  icon: 'onboarding-paper',
                  icon_height: '17px',
                  class: 'green'
                },
                {
                  option: `Just headlines`,
                  slug: 'headlines',
                  icon: 'onboarding-deeper',
                  icon_height: '18px',
                  class: 'yellow'
                },
                {
                  option: `Not much`,
                  slug: 'light',
                  icon: 'onboarding-find',
                  icon_height: '18px',
                  class: 'blue'
                },
              ]
            },

            // {
            //   type: 'onboarding',
            //   slug: 'ready',
            //   template: 'ready',
            //   dot: false,
            // },

            {
              type: 'question',
              slug: 'focus',
              byline: `Let's get started…`,
              title: `What shall we focus on first?`,
              paragraph: `Let’s start off by focusing on Time, Topics or Countries.`,
              // action: {
              //   message: `Spoiler alert: We'll help with all three, but let's start with the one that matters most to you.`
              // },
              questions: [
                {
                  option: `Time`,
                  byline: `Focus on spending just enough time reading each day.`,
                  slug: 'time',
                  dial: true,
                  class: 'time',
                },
                {
                  option: `Topics`,
                  byline: `Focus on covering a range of different topics.`,
                  slug: 'topics',
                  dial: true,
                  class: 'topics',
                },
                {
                  option: `Countries`,
                  byline: `Focus on reading news from countries around the world.`,
                  slug: 'locales',
                  dial: true,
                  class: 'locales',
                }
              ]
            },


            {
              type: 'auth',
              slug: 'auth',
              dot: false,
            },

            {
              type: 'finalise',
              slug: 'finalise',
              byline: 'Almost there',
              title: `Just a moment`,
              paragraph: `We're setting Nourish up just for you. This will only take a moment.`,
              dot: false,
            },
          ]
        }

        if (this.device !== 'apple' && this.device !== 'android') {
          flow.structure.push(
            {
              type: 'download-app',
              slug: 'download-app',
              hideNext: true,
              byline: 'Nourish at your fingertips',
              title: `Get the Nourish app`,
              paragraph: `For the best possible news experience, scan the QR code and download the app. Available on iOS and Android.`
            },
          )
        }

        if (this.device === 'apple') {
          flow.structure.push(
            {
              type: 'notifications',
              slug: 'notifications',
              content: {
                byline: `Enable notifications, never miss an update and we'll keep you on track with reading news in a healthy way.`,
                title: `Never miss an important story`,
              },
              dot: false,
            }
          )
        }

        // Remove auth for signed in users
        // console.log('Started SignedIn:', this.bSignedInAtStart)
        
        if (this.bSignedInAtStart) {
          // Remove card
          const idx = flow.structure.findIndex(item => item.type === 'auth');
          if (idx !== -1) {
            flow.structure.splice(idx, 1);
          }

          // Add loading card
          // flow.structure.push({
          //   type: 'finalise',
          //   slug: 'finalise',
          //   byline: 'Almost there',
          //   title: `Just a moment`,
          //   paragraph: `We're setting Nourish up just for you. This will only take a moment.`
          // })
        }

        // If onboarding from invite, include invite intro and remove general intro
        if (this.$route.query.n === 'invite') {
          // Remove general intro
          const idx = flow.structure.findIndex(item => item.type === 'onboarding');
          if (idx !== -1) {
            flow.structure.splice(idx, 1);
          }
          // Add invite intro
          flow.structure.unshift({
            type: 'invite',
            slug: 'invite',
            dot: false,
          });
        }

        // If signed in and doesn't have notifications enabled and is on app
        // if (this.isSignedIn && this.isApp && !this.getAccount.details.updatesMobileOn) {
        //   flow.structure.push({
            // type: 'notifications',
            // slug: 'notifications',
            // content: {
            //   byline: 'Enable notifications, never miss an update and keep your streak on track.',
            //   title: `Stay in the know`,
            // },
            // dot: false,
        //   })
        // }

        return flow
      },

      debugFlow() {
        return this.getStructure.map(a => `${a.type}:${a.slug}`);
      },

      collections() {
        return this.$store.getters.getStackShelves;
      },

      currentStack() {
        if (this.apiExempt || !this.collections) { return {} }

        const playlists = this.collections.flatMap(collection => collection.features);

        if (!this.stack?.meta?.slug) {
          return {};
        }

        return playlists.find(item => {
          const slug = item?.slug?.includes(':')
            ? item?.slug.split(':').pop()
            : item?.slug;
          return slug === this.stack?.meta?.slug;
        }) || {};
      },

      getStructure() {
        return this.stack.structure || [{
          type: 'intro',
        }];
      },

      getStories() {
        return this.stack.stories;
      },

      getArticles() {
        return this.stack.articles;
      },

      showImage() {
        // default ('preview') has no image
        // console.log(`showImage: `, this.oCard.type, this.featured, this.featuredImage);

        if (!this.oCard?.type) {
          return false;
        }

        switch (this.oCard?.type) {
          case 'intro': // new "video preview!"
          case 'achievement':
          case 'breathe':
          case 'completed':
          case 'notifications':
          case 'switch-off':
            return false;
        }

        if (this.featuredImage) {
          return true;
        }

        if (['default', 'bio', 'focus'].includes(this.currentStack.type) && this.featured) { return true; } return false;
      },

      showMap() {
        if (this.currentStack.type === 'geo' && !this.isIntro) { return true; } return false;
      },

      isIntro() {
        return this.oCard?.type === 'intro';
      },

      isFullSize() {
        // default to full size
        return !this.oCard?.type || (['intro', 'invite', 'onboarding', 'score', 'question', 'auth', 'finalise', 'notifications'].includes(this.oCard?.type));
      },

      featured() {
        if (this.featuredImage) {
          return {
            image: this.featuredImage
          };
        }

        let images = [];
        let aSlugs = this.oCard?.meta?.stories;

        // no story slugs? assume just articles...
        
        if (!aSlugs.length) {
          let sArticleSlug = Object.keys(this.oCard?.meta?.extra).filter(s => /^arx_/.test(s))?.pop()?.replace(/^arx_/, '');
          let oArticle = this.stack.articles?.filter(o => o.slug == sArticleSlug).pop();
          if (!oArticle.slug) {
            return;
          }
          let oImage = {
            story: '-',
            article: sArticleSlug,
            image: oArticle.image,
            photo: oArticle.photo,
            publisher: oArticle.publisher,
            caption: oArticle.name,
          }
          return oImage;
        }



        // find a deterministically pseudo-random story image..

        this.stack?.stories?.forEach(story => {
          if (aSlugs?.length && !aSlugs.includes(story.slug)){
            return;
          }
          story?.articles?.forEach(article => {
            images.push({
              story: story.slug,
              article: article.slug,
              image: article.image,
              photo: article.photo,
              publisher: article.publisher,
              caption: article.name,
            });
          });
        });

        // it's nonsense but it's deterministic (so it doesn't jitter -- speak to Jim)
        return images.filter(a => a.photo).sort((a, b) => {
          if (a.story == b.story) {
            return a.article > b.article ? -1 : 1;
          }
          return a.story > b.story ? -1 : 1;
        }).pop();
      },

      backgroundStyle() {
        return {
          backgroundImage: `url('${this.getImageUrl}')`,
          opacity: this.imageOpacity,
          transform: `translateY(${(1 - this.imageOpacity) * 100}px)`
        };
      },

      getImageUrl() {
        return this.featured?.image;
      },

      mapBackgroundStyle() {
        return {
          opacity: this.imageOpacity,
          transform: `translateY(${(1 - this.imageOpacity) * 150}px)`
        };
      },

      getDialFocus() {
        return this.$coachingEngine.getDialFocus;
      },

      isEndCard() {
        return this.currentSlide?.end;
      }
    },

    methods: {
      async fetchStack() {
        // console.log(`\x1b[36mfetchStack :(${this.apiExempt}) exempt, :${this.stackSlug}, :${this.editionSlug}`);
        if (!this.apiExempt) {
          // await API.getStackShelves();
          if (this.stackSlug) {
            await API.getStack(this.stackSlug, this.editionSlug);
          }
          // snapshot the dial at launc
          this.$userEngine.dialSnapshot();
        }

        // Fetch thread if thread card
        if (this.stackSlug === 'thread') {
          await this.getThread();
        }
      },
      
      showDesk(sSlug, bBoth = false) {
        // obs only when we're actually ON desktop!
        if (!bBoth && !this.isDesktop) {
          return false;
        }
        
        // history, desktop etc... set up as you go
        if (sSlug == this.stackSlug) {
          return true;
        }

        // special case for standard news stacks from the API
        if ((sSlug == 'stack') && !this.apiExempt) {
          return true;
        }

        return false;
      },

      getThread() {
        API.getThread(this.threadSlug.author, this.threadSlug.slug).then((response) => {
          // console.log('RES', response)
          this.thread = response;
        }).catch((error) => {
          console.error(error);
        })
      },

      hackDeskBounce() {
        // console.log(`****** Checking bounce:`);
        // we're already mobile ... stick with it .. 
        if (this.$mq == 'sm') {
          return 'sm';
        }

        // already in a frame?
        let bFramed = false;
        try {
          bFramed = window.self !== window.top;
        } catch (e) {
          bFramed = false;
        }
        
        // if so, ignore..
        if (bFramed) {
          return 'fr';
        }

        // do we recognise the route? /n/foo
        if (this.$route.path.search(/^\/n\//) == -1) {
          return 'path';
        }

        // okay - we're desktop (or medium?) .. and we're not framed ... we're on a swiper-looking URL ... so let's bounce!
        let sPath = this.$route.path.replace(/^\/n\//, '/d/') + (Object.keys(this.$route.query).length ? '?' + new URLSearchParams(this.$route.query).toString() : '');
        
        // go!
        // console.log(`Redirecting ---> ${sPath}`);
        // this.$router.push(sPath);
        top.location.replace(sPath);

        // and stop the mount?
        return false;
      },

      setCurrentCard() {
        const swiper = this.$refs.swiper;
        if (!swiper) { return; }
        this.oCard = this.stack.structure[swiper.swiper.realIndex];
        if (swiper.swiper.realIndex > 0) {
          this.$layoutEngine.goDeepSwiper();
        }
      },

      outro() {
        const swiper = this.$refs.swiper;
        if (!swiper) { return; }
        const outroIdx = this.stack.structure.findIndex(item => item.type === 'outro');
        const outro = this.stack.structure[outroIdx]

        if (!outro) {
          return;
        }

        this.$router.push({ path: `/n/${this.stackSlug}/${outro.slug}`, query: this.$route.query });
        this.haptic('medium');
      },


      // wrap some preflight (that might insert another card)
      next(force) {
        const swiper = this.$refs.swiper;
        if (!swiper) { return; }

        // tell the layout engine we're in (hacky! sorry)
        this.$layoutEngine.goDeepSwiper();

        let bWait = this.nextPreflight();

        if (bWait) {
          this.$nextTick(() => {
            this.nextDo();
          })
          return null;
        }

        this.nextDo(force);
      },

      nextPreflight() {
        const swiper = this.$refs.swiper;
        if (!swiper) { return; }
        
        const response = this.commitTracking();

        if (response) {
          // Get current slide for slug
          const currentSlide = this.stack.structure[swiper.swiper.realIndex];
          
          // Adjust response slug
          response.slug = `${response.slug}-${currentSlide.slug}`

          // Inject the slide
          this.stack.structure.splice(swiper.swiper.realIndex + 1, 0, response);

          // Update swiper
          this.swiperUpdate();

          return true;
        }
      },

      // the actual `next()` - but sometimes we need to wait for a tick..
      nextDo(force) {
        const swiper = this.$refs.swiper;
        if (!swiper) { return; }

        this.EventBus.$emit('stack:snap-scroll', {
          scrollTop: 0,
        });

        const currentSlide = this.stack.structure[swiper.swiper.realIndex];
        const nextSlide = this.stack.structure[swiper.swiper.realIndex + 1];

        this.enableNext = false;
        this.updateActionBar();

        // last
        if (!force && (swiper.swiper.realIndex === this.stack.structure.length - 1 || currentSlide?.end)) {
          // At the end of the stack
          if (this.stackSlug === 'profile') {
            // Profile setup complete. Redirect back to invites
            this.$userEngine.setPref('nourish.invites.setup', true);
            this.$router.push(`/~${this.getAccount.screen_name}/invite`);
          } else if (/^coaching:/.test(this.stackSlug)) {
            // Profile setup complete. Redirect back to invites
            
            // ~ only mark when it's the right `coaching:` stack (there are more now, one for each day..) 
            if (['coaching:time', 'coaching:topics', 'coaching:locales'].includes(this.stackSlug)) {
              this.$coachingEngine.coachingSeen();
            }

            this.$router.push('/');
          } else {
            this.$router.push('/');
          }
          this.haptic('success');
        } else {
          this.$router.push({ path: `/n/${this.stackSlug}/${nextSlide.slug}`, query: this.$route.query });
          this.haptic('medium');
        }

        setTimeout(() => {
          if (nextSlide?.type === 'intro' || nextSlide?.type === 'outro') {
            this.focusCountry = 'GB';
          } else {
            if (nextSlide?.meta?.locales?.length) {
              this.focusCountry = nextSlide.meta?.locales[0].iso.toUpperCase();
            }
          }
        }, 200);

      },

      featureImage(image) {
        // console.log(`FEATURE IMAGE: ${image}`);
        this.featuredImage = image
      },

      swiperUpdate() {
        const swiper = this.$refs.swiper;
        swiper.swiper.update();
      },

      readMore() {
        // Read more and force navigation
        this.next(true);
      },
      
      close() {
        // make sure we commit where we're at
        this.commitTracking();
        // ... and this should be better probably
        // this.$router.push('/');
        this.$emit('close');
        this.haptic('warning');
        this.EventBus.$emit('stack:close');
      },

      haptic(note) {
        this.EventBus.$emit("device:haptic", note);
      },

      handleRoute() {        
        const swiper = this.$refs.swiper;
        const idx = swiper?.swiper?.slides?.findIndex((slide) => slide.id === this.cardSlug)
        // console.log(`sliding to... ${idx}`);
        swiper?.swiper?.slideTo(idx);
        this.updateActionBar();
      },

      updateActionBar() {
        const swiper = this.$refs.swiper;
        // if (!swiper || swiper.destroyed) {
        //   return;
        // }

        let realIdx = 0;
        let isEnd = false;
        let stats = { read: 0 };

        if (swiper) {
          if (swiper.swiper) {
            realIdx = swiper.swiper?.realIndex;
            isEnd = swiper?.swiper?.isEnd;
          }

          if (swiper.swiper?.realIndex < this.currentStack?.stats?.read) {
            this.enableNext = true;
          }
        }

        if (Object.keys(this.currentStack).length > 0) {
          stats = this.currentStack.stats
        }

        let payload = {
          show: true,
          structure: this.stack.structure,
          index: realIdx,
          stats: stats,
          isEnd: isEnd,
          enableNext: this.enableNext,
          disableLabel: this.apiExempt ? '' : 'Scroll',
        };

        // console.log(`updateActionBar: `, payload);
        // is the swiper *nearly* window height?
        
        if (!this.apiExempt) { // only on API (news) swipers for now.. :facepalm:
          let iSwiperPX = (swiper?.clientHeight || 0) / window.innerHeight;
          if (iSwiperPX <= 1.1) { // if there less than 10% overscroll, enable anyway
            payload.enableNext = true;
          }
        }
        // console.log(`tab:update`,iSwiperPX, payload);

        this.EventBus.$emit('tab:update', payload)
      },

      enableNextAction(shouldEnable) {
        this.enableNext = shouldEnable || true;
        if (this.enableNext) {
          this.EventBus.$emit('tab:hide-next', false)
        }
      },

      handleScroll() {
        // const currentScrollTop = window.pageYOffset || document.documentElement.scrollTop;
        // const windowHeight = window.innerHeight;
        // const fullHeight = document.documentElement.offsetHeight;

        // // Watch scroll position for page end
        // console.log(`cst: ${currentScrollTop} + wh: ${windowHeight} >= fh: ${fullHeight} - 50`);
        // if (currentScrollTop + windowHeight >= fullHeight - 50) {
        //   this.enableNext = true;
        // }

        // // Manage image opacity
        // const fadeStart = 0;
        // const fadeEnd = 400;

        // let opacity = 1;
        // if (currentScrollTop <= fadeStart) {
        //   opacity = 1;
        // } else if (currentScrollTop >= fadeEnd) {
        //   opacity = 0;
        // } else {
        //   opacity = 1 - (currentScrollTop - fadeStart) / (fadeEnd - fadeStart);
        // }

        // this.imageOpacity = opacity;
      },

      commitTracking() {
        // for now, don't track things that didn't come from the API
        if (this.apiExempt) {
          return;
        }
        // HORRIBLE! ... in the database, at the moment... `around-the-world` is actually `:around-the-world` ... to mark it as an indiosyncratic pattern... eugh.
        let oPayload = {};
        oPayload.feature = /^pattern/.test(this.stackSlug) ? this.stackSlug.replace(/pattern:/, '') : `:${this.stackSlug}`;
        oPayload.edition = this.editionSlug;
        oPayload.card = this.cardSlug;
        oPayload.time = Math.ceil(((new Date()).getTime() - this.iTimeStart) / 1000);
        this.$userEngine.stackRead(oPayload);

        return false;

        // if (Math.random() > .5) {
        //   return false;
        // }

        // // Achievement card example
        // return {
        //   type: 'achievement',
        //   slug: 'achievement',
        //   content: {
        //     title: 'Great work!',
        //     byline: `You've read your first ever story on Nourish and already making great progress!`,
        //     dial: false,
        //     topics: [
        //       {
        //         img: '/flags/uk.png',
        //         name: 'Ukraine'
        //       }
        //     ]
        //   }
        // };

        // Breathe card example
        // return {
        //   type: 'breathe',
        //   slug: 'breathe',
        //   content: {
        //     title: 'Phew! That was a bit of an intense story.',
        //     byline: `Take a few moments to breathe before moving onto the next.`,
        //   }
        // };

        // Complete card example
        // return {
        //   type: 'completed',
        //   slug: 'completed',
        //   content: {
        //     title: `Look at that, you've read everything you needed to.`,
        //     byline: `Your dial is completely full! There's nothing else you need to read today.`,
        //   }
        // };

        // Notifications card example
        // return {
        //   type: 'notifications',
        //   slug: 'notifications',
        //   content: {
        //     title: `Keep the good times rollin'`,
        //     byline: `Get reminded to come back tomorrow and keep your streak alive.`,
        //   }
        // };

        // Switch off card example
        // return {
        //   type: 'switch-off',
        //   slug: 'switch-off',
        //   content: {
        //     title: `Trust us, you've read enough for today`,
        //     byline: `Go outside, get some fresh air, you've covered all the news you need to know. Come back tomorrow.`,
        //   }
        // };
      },
    },

    activated() {
      // console.log(`\x1b[36mActivated!`);
      if (!this.stack) {
        this.fetchStack().then(() => {
          this.iTimeStart = (new Date()).getTime();
          this.setCurrentCard();
          this.updateActionBar();
        })
      } else {
        this.updateActionBar();
      }
    },

    watch: {
      '$route.params.stack': {
        handler() {
          this.handleRoute();
          // console.log(`\x1b[31m Flow: `, this.debugFlow);
        }
      },

      enableNext: {
        handler() {
          this.updateActionBar()
        }
      },

      cardSlug() {
        if (this.stack && Object.keys(this.stack).length > 0) {
          this.iTimeStart = (new Date()).getTime();
          this.setCurrentCard();
        }
      },
    },
  }
</script>

<style lang="scss" scoped>
  @import 'src/assets/scss/v5.scss';

  // .swiper {
  //   margin-top: calc(env(safe-area-inset-top) - $header-height);
  //   .mini & {
  //     margin-top: calc(env(safe-area-inset-top));
  //   }
  // }

  .swiper-container {
    background: transparent !important;
  }

  .swiper-wrap {
    position: relative;
    // min-height: 100vh;
    min-height: calc(100vh - calc(env(safe-area-inset-top) + 1.5rem));
    // padding-bottom: 3rem;
    // min-height: calc(100vh - env(safe-area-inset-top) - $header-height);
    background: $neutral-600;

    .darkmode & {
      background: $neutral-100;
    }

    .desktop & {
      .darkmode & {
        background: $neutral-200;
      }
    }

    .safe-area-blur {
      position: fixed;
      top: 0;
      left: 0;
      right: 0;
      height: env(safe-area-inset-top);
      backdrop-filter: blur(3px);
      z-index: 2;
    }

    .close {
      position: absolute;
      z-index: 2;
      // top: calc(env(safe-area-inset-top) + 2.25rem);
      top: 1rem;
      right: 0.75rem;
      display: flex;
      align-items: center;
      justify-content: center;
      width: 44px;
      height: 44px;
      padding: 0;
      margin-left: auto;
      border-radius: 500px;
      // background: rgba(0,0,0, 1);
      background: none;
      cursor: pointer;

      svg {
        filter: drop-shadow(0 6px 14px rgba(0, 0, 0, 0.6))
                drop-shadow(0 3px 6px rgba(0, 0, 0, 0.3));
      }

      svg path {
        fill: $neutral-600;
      }

      .darkmode & {
        // background: rgba(0,0,0, 1);

        svg path {
          fill: $neutral-600;
        }
      }

      &.hasImage {
        // background: rgba($neutral-100, 0.15);
        // backdrop-filter: blur(10px);

        svg path {
          fill: $neutral-600;
        }
      }
    }

    .desktop-next {
      position: absolute;
      z-index: 2;
      top: 1rem;
      right: 4.5rem;
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 0.5rem;
      width: 6rem;
      height: 2.8rem;
      padding: 0;
      margin-left: auto;
      border-radius: 500px;
      background: rgba(0,0,0, 1);
      color: white;
      cursor: pointer;

      svg path {
        fill: $neutral-600;
      }

      .darkmode & {
        background: rgba(0,0,0, 1);

        svg path {
          fill: $neutral-600;
        }
      }
    }

    .stacks {
      height: 100%;

      .slide {
        // display: flex;
        overflow-x: hidden;
        // force a reasonable min-height, even when there's no content
        min-height: calc(100vh - 3rem - env(safe-area-inset-top) - env(safe-area-inset-bottom)) !important;

        .content {
          width: 100%;
          // adopt the height of the slide 
          min-height: 100% !important;
          // position: relative; // removed JM 1 Sep - because it shrinks the .content and removes your ability to position: abs, other things to the parent's boundary..


          z-index: 2;
          overflow-x: hidden;

          &:not(.isFullSize) {
            padding-top: calc(env(safe-area-inset-top) + 4rem);
            padding-bottom: calc(env(safe-area-inset-bottom) + 6rem);
            padding-left: 1.5rem;
            padding-right: 1.5rem;
            // min-height: 100vh;

            .desktop & {
              padding-bottom: calc(env(safe-area-inset-bottom) + 4rem);
            }
          }

          &.type-invite,
          &.type-onboarding,
          &.type-score,
          &.type-question,
          &.type-auth,
          &.type-finalise,
          &.type-notifications {
            padding-top: 2em;
            padding-left: 1rem;
            padding-right: 1rem;
          }

          &.hasImage {
            padding-top: 0;
            margin-top: calc(-1 * (5rem - env(safe-area-inset-top)));
          }

          &.hasMap {
            padding-top: 20rem;
          }

          &.isIntro {
            padding-top: 0;
          }
        }

        &.slide-go-pro {
          .content {
            background: $green-tone-6;
            color: $neutral-600;
            padding: 0;
          }
        }

        &.slide-unlock {
          .content {
            background: $neutral-600;
            color: $neutral-100;
            padding: 0;

            .darkmode & {
              background: $neutral-100;
              color: $neutral-600;
            }
          }
        }

        &.slide-newsle {
          .content {
            height: calc(100vh - calc(env(safe-area-inset-top) + 1.5rem));
            padding: 0;
            // padding-bottom: calc(env(safe-area-inset-bottom) + 6rem);

            .card-newsle,
            .wrapper,
            .container {
              height: 100%;
            }
          }
        }

        &.slide-newsle-intro {
          .content {
            height: calc(100vh - calc(env(safe-area-inset-top) + 1.5rem));
            padding: 0;
            // padding-bottom: calc(env(safe-area-inset-bottom) + 6rem);

            .card-newsle,
            .wrapper,
            .container {
              height: 100%;
            }
          }
        }
      }

      &.slide-story-card {
        .content {
          padding-bottom: calc(env(safe-area-inset-bottom) + 4rem + 3rem);
        }
      }
    }

    .image,
    .map {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      height: calc(40vh + env(safe-area-inset-top));
      display: flex;
      z-index: 0;
      transition: opacity 0.03s linear, transform 0.03s linear;
    }

    .image-wrap {
      position: relative;

      // horrible FORCE chrome to behave (probably the opacity that's doing it)
      transform: translate3d(0, 0, 0);
      backface-visibility: hidden;
      opacity: 0.999;

    }

    .blur {
      // will-change: opacity, transform, backdrop-filter;
      // z-index: 2;
      position: absolute;
      display: flex;

      // horrible FORCE chrome to behave (probably the opacity that's doing it)
      transform: translate3d(0, 0, 0);
      backface-visibility: hidden;
      opacity: 0.999;
      

      // inset: 50% 0 0 0;
      inset: 60% 0 0 0;
      // height: calc(40vh + env(safe-area-inset-top));

      mask: linear-gradient(transparent, black, black);
      backdrop-filter: blur(10px);
      pointer-events: none;

      // .desktop & {
      //   mask: linear-gradient(transparent, black, $neutral-200);
      // }
    }

    .image {
      

      
      // horrible FORCE chrome to behave (probably the opacity that's doing it)
      transform: translate3d(0, 0, 0);
      backface-visibility: hidden;
      opacity: 0.999;
      



      position: static;
      display: block;
      overflow: hidden;

      will-change: transform;
      background-size: cover;
      background-position: center;
      background-repeat: no-repeat;

      // &.reduced {
        height: calc(30vh + env(safe-area-inset-top));
      // }

      .desktop & {
        height: calc(45vh + env(safe-area-inset-top));
      }

      &::after {
        content: "";
        position: absolute;
        inset: 0;
        background: rgba(0, 0, 0, 0.1);
      }

      &::before {
        z-index: 1;
        content: "";
        position: absolute;
        inset: 0;
        background-image: linear-gradient(
          180deg,
          rgba($neutral-600, 0.0) 0%,
          rgba($neutral-600, 0.1) 30%,
          rgba($neutral-600, 0.2) 50%,
          rgba($neutral-600, 0.6) 70%,
          rgba($neutral-600, 0.8) 85%,
          $neutral-600 95% /* reach white/black with enough space for blur */
        );
        pointer-events: none;
      }

      .darkmode & {
        &::before {
          background-image: linear-gradient(
            180deg,
            rgba($neutral-100, 0.0) 0%,
            rgba($neutral-100, 0.1) 30%,
            rgba($neutral-100, 0.2) 50%,
            rgba($neutral-100, 0.6) 70%,
            rgba($neutral-100, 0.8) 85%,
            $neutral-100 95%  /* reach white/black with enough space for blur */
          );
        }
      }

      .desktop & {
        .darkmode & {
          &::before {
            background-image: linear-gradient(
              180deg,
              rgba($neutral-200, 0.0) 0%,
              rgba($neutral-200, 0.1) 30%,
              rgba($neutral-200, 0.2) 50%,
              rgba($neutral-200, 0.6) 70%,
              rgba($neutral-200, 0.8) 85%,
              $neutral-200 95%  /* reach white/black with enough space for blur */
            );
          }
        }
      }
    }


    .map {
      width: 100%;

      &.reduced {
        height: calc(25vh + env(safe-area-inset-top));
      }
    }
  }
</style>